import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export function procedureBaseRoute(name: string): RouteConfig {
  return {
    path: 'base',
    name,
    component: () => import(/* webpackChunkName: "ProcedureBase" */ '@/views/mainRoute/procedure/steps/Base.vue'),
    meta: {},
    beforeEnter(to, from, next) {
      store
        .dispatch('template/list', { order: 'name', desc: false, count: -1 })
        .then(() => next())
        .catch(err => store.dispatch('notifyError', { title: Errors.TEMPLATE_CANNOT_LIST }));
    }
  };
}
